import {css} from 'lit';
export const styles = css`h3{display:flex;flex-direction:row;gap:1rem}h3 platform-product-icon{flex:0 0 var(--platform-header-product-heading-icon-size);height:auto}slot+h3{border-top:1px solid var(--menu-font-color);margin-top:1rem;padding-top:1rem}`;
export default styles;
